define('app/views/produtos',['require','backbone','twig','text!../tpl/produtos.twig','../collections/produtos','../models/paginacao'],function(require){
    
    var Backbone = require('backbone');
    var Twig = require('twig');
    
    String.prototype.linkfy = function() {
        var str = this;
        var chars = {
            '/ä|æ|ǽ/' : 'ae',
            '/ö|œ/' : 'oe',
            '/ü/' : 'ue',
            '/Ä/' : 'Ae',
            '/Ü/' : 'Ue',
            '/Ö/' : 'Oe',
            '/À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ/' : 'A',
            '/à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª/' : 'a',
            '/Ç|Ć|Ĉ|Ċ|Č/' : 'C',
            '/ç|ć|ĉ|ċ|č/' : 'c',
            '/Ð|Ď|Đ/' : 'Dj',
            '/ð|ď|đ/' : 'dj',
            '/È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě/' : 'E',
            '/è|é|ê|ë|ē|ĕ|ė|ę|ě/' : 'e',
            '/Ĝ|Ğ|Ġ|Ģ/' : 'G',
            '/ĝ|ğ|ġ|ģ/' : 'g',
            '/Ĥ|Ħ/' : 'H',
            '/ĥ|ħ/' : 'h',
            '/Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ/' : 'I',
            '/ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı/' : 'i',
            '/Ĵ/' : 'J',
            '/ĵ/' : 'j',
            '/Ķ/' : 'K',
            '/ķ/' : 'k',
            '/Ĺ|Ļ|Ľ|Ŀ|Ł/' : 'L',
            '/ĺ|ļ|ľ|ŀ|ł/' : 'l',
            '/Ñ|Ń|Ņ|Ň/' : 'N',
            '/ñ|ń|ņ|ň|ŉ/' : 'n',
            '/Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ/' : 'O',
            '/ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º/' : 'o',
            '/Ŕ|Ŗ|Ř/' : 'R',
            '/ŕ|ŗ|ř/' : 'r',
            '/Ś|Ŝ|Ş|Š/' : 'S',
            '/ś|ŝ|ş|š|ſ/' : 's',
            '/Ţ|Ť|Ŧ/' : 'T',
            '/ţ|ť|ŧ/' : 't',
            '/Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ/' : 'U',
            '/ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ/' : 'u',
            '/Ý|Ÿ|Ŷ/' : 'Y',
            '/ý|ÿ|ŷ/' : 'y',
            '/Ŵ/' : 'W',
            '/ŵ/' : 'w',
            '/Ź|Ż|Ž/' : 'Z',
            '/ź|ż|ž/' : 'z',
            '/Æ|Ǽ/' : 'AE',
            '/ß/': 'ss',
            '/Ĳ/' : 'IJ',
            '/ĳ/' : 'ij',
            '/Œ/' : 'OE',
            '/ƒ/' : 'f'
        };
        var result = str;
        $.each(chars,function(index,char){
            var regex = new RegExp(index,'igm');
            result = result.replace(regex,char).toLowerCase();
        });
        return $.trim(result.replace(/\s+/igm,' ')).replace(/\s/igm,'-');
    };
    
    Twig.extendFilter("linkfy",function(value) {
        
        return value.titulo.linkfy()+'-'+value.id;
        
    });
    
    var tpl = require('text!../tpl/produtos.twig');
    var template = Twig.twig({data:tpl});
    
    var produtos = require('../collections/produtos');
    var paginacao = require('../models/paginacao');
    
    
    
    
    var view = Backbone.View.extend({
        initialize: function () {
            var that = this;
            
            that.data = {};
            
            that.listenTo(produtos,'all',that.render);            
            
            that.render();
        },
        render: function () {
            var that = this;
            
            if (that.timer) {
                window.clearTimeout(that.timer);
            }
            that.timer = window.setTimeout(function(){                
                
                
                var data = $.extend({},that.data);
                
                data.produtos = produtos.toJSON();
                
                that.$el.html(template.render(data));
                
            },100);
            return that;                
        }
    });
    
    return view;
    
});
